var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12"},[_c('indexHeader',{attrs:{"title":_vm.$t('deliveries.freightForwarders'),"description":_vm.$t('deliveries.FromHereYouCanControlTheShippingAgents')}}),_c('indexTable',{attrs:{"searchText":_vm.$t('deliveries.LookingForAShippingRepresentative'),"emptyTableText":_vm.$t('deliveries.ThereAreNoShippingAgents'),"localData":true,"buttonRole":true,"emptyTableSubText":_vm.$t('allerts.TryAddingSomeItemsToTheTableAndTryAgain'),"cloumns":[
          {
            column: 'name',
            title: _vm.$t('deliveries.ShippingRepresentativeIsName'),
            type: 'text',
            sort: true
          },
          {
            column: 'safe_id',
            title: _vm.$t('deliveries.Treasury'),
            type: 'link',
            to: 'safe',
            sort: true,
            link: true
          },
          {
            column: 'balance',
            title: _vm.$t('deliveries.balance'),
            type: 'text',
            sort: true
          },
          {
            column: 'options',
            title: _vm.$t('deliveries.settings'),
            type: 'options',
            options: [
              { name: 'edit', role: true },
              { name: 'delete', role: true }
            ]
          }
        ],"deleteText":{
          attention: _vm.$t('allerts.Attention'),
          areYouReallySureToDeleteTheItem: _vm.$t('allerts.areYouReallySureToDeleteTheItem'),
          close: _vm.$t('allerts.close'),
          confirm: _vm.$t('allerts.confirm'),
          loading: _vm.$t('allerts.loading')
        }}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }